import { LocaleId } from '@domgen/dgx-fe-i18n';
import {
  AdobeRequest,
  CustomerDetails,
  RegistrationApplianceDetails,
  RegistrationRequest,
} from '@us-registration/util-models';

export function getAdobeCampaignRequest(
  campaignBrandCode: string,
  campaignEventType: string,
  registrationRequest?: RegistrationRequest
): AdobeRequest | undefined {
  if (!registrationRequest) {
    return;
  }

  const customerDetails: CustomerDetails = registrationRequest.customer;
  const registrationApplianceDetails: RegistrationApplianceDetails =
    registrationRequest.merchandise[0];

  return {
    brand: campaignBrandCode,
    cleartext: 'mcApi',
    email: customerDetails.email as string,
    eventType: campaignEventType,
    externalId: 'loggedinuserid',
    firstName: customerDetails.firstName as string,
    language: LocaleId.English_US,
    lastName: customerDetails.lastName as string,
    modelNum: registrationApplianceDetails.modelNumber as string,
    name: 'mcApi',
    origin: `REG${campaignBrandCode}`,
    serialNum: registrationApplianceDetails.serialNumber as string,
  };
}
